import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { userApi } from 'features/user/query';
import { UserState } from 'features/user/types';

const initialState: UserState = {
  userList: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: builder => {
    const { GetUserDetailList } = userApi.endpoints;

    builder
      .addMatcher(GetUserDetailList.matchFulfilled, (state, { payload }) => {
        state.userList = payload.userDetails ?? null;
      })
      .addMatcher(
        isAnyOf(
          GetUserDetailList.matchPending,
          GetUserDetailList.matchRejected
        ),
        state => {
          state.userList = null;
        }
      );
  },
});

export default userSlice.reducer;
